export const isMaliciousOrSuspicious = (classification) => {
    return ["Malicious", "Suspicious"].includes(classification);
};
//# sourceMappingURL=classification.js.map